module.exports = __webpack_public_path__ + "static/media/bg_top_m.7c954860.png";